/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Current_Pain_YesInputs */

const en_us2_onboarding_current_pain_yes = /** @type {(inputs: Onboarding_Current_Pain_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, something hurts`)
};

const pt_br2_onboarding_current_pain_yes = /** @type {(inputs: Onboarding_Current_Pain_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, algo dói`)
};

const es_419_onboarding_current_pain_yes = /** @type {(inputs: Onboarding_Current_Pain_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, algo me duele`)
};

const pt_pt2_onboarding_current_pain_yes = /** @type {(inputs: Onboarding_Current_Pain_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, algo dói`)
};

const fr_fr2_onboarding_current_pain_yes = /** @type {(inputs: Onboarding_Current_Pain_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, j'ai mal quelque part`)
};

const de_de2_onboarding_current_pain_yes = /** @type {(inputs: Onboarding_Current_Pain_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, etwas tut weh`)
};

const it_it2_onboarding_current_pain_yes = /** @type {(inputs: Onboarding_Current_Pain_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, qualcosa fa male`)
};

/**
* | output |
* | --- |
* | "Yes, something hurts" |
*
* @param {Onboarding_Current_Pain_YesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_current_pain_yes = /** @type {((inputs?: Onboarding_Current_Pain_YesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Current_Pain_YesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_current_pain_yes(inputs)
	if (locale === "es-419") return es_419_onboarding_current_pain_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_current_pain_yes(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_current_pain_yes(inputs)
	if (locale === "de-DE") return de_de2_onboarding_current_pain_yes(inputs)
	if (locale === "it-IT") return it_it2_onboarding_current_pain_yes(inputs)
	return en_us2_onboarding_current_pain_yes(inputs)
});
export { onboarding_current_pain_yes as "onboarding.current_pain.yes" }